"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.size = exports.device = exports.default = exports.color_tertiary_8 = exports.color_tertiary_7 = exports.color_tertiary_6 = exports.color_tertiary_5 = exports.color_tertiary_4 = exports.color_tertiary_3 = exports.color_tertiary_2 = exports.color_tertiary_1 = exports.color_secondary_2 = exports.color_secondary_1 = exports.color_primary_7 = exports.color_primary_6 = exports.color_primary_5 = exports.color_primary_4 = exports.color_primary_3 = exports.color_primary_2 = exports.color_primary_1 = void 0;
// Define the palette
var color_primary_1 = "#f1f0f1";
exports.color_primary_1 = color_primary_1;
var color_primary_2 = "#0b237f";
exports.color_primary_2 = color_primary_2;
var color_primary_3 = "#132e96";
exports.color_primary_3 = color_primary_3;
var color_primary_4 = "#132e12";
exports.color_primary_4 = color_primary_4;
var color_primary_5 = "#ff3355";
exports.color_primary_5 = color_primary_5;
var color_primary_6 = "#ff3355";
exports.color_primary_6 = color_primary_6;
var color_primary_7 = "#ff3355";
exports.color_primary_7 = color_primary_7;
var color_secondary_1 = "#000000";
exports.color_secondary_1 = color_secondary_1;
var color_secondary_2 = "#ffffff";
exports.color_secondary_2 = color_secondary_2;
var color_tertiary_1 = "#f5d765";
exports.color_tertiary_1 = color_tertiary_1;
var color_tertiary_2 = "#ff9000";
exports.color_tertiary_2 = color_tertiary_2;
var color_tertiary_3 = "#ec0048";
exports.color_tertiary_3 = color_tertiary_3;
var color_tertiary_4 = "#8a45b6";
exports.color_tertiary_4 = color_tertiary_4;
var color_tertiary_5 = "#59a2d0";
exports.color_tertiary_5 = color_tertiary_5;
var color_tertiary_6 = "#c5fa8a";
exports.color_tertiary_6 = color_tertiary_6;
var color_tertiary_7 = "#272727";
exports.color_tertiary_7 = color_tertiary_7;
var color_tertiary_8 = "#d7d3ca"; // named sizes for screen widths.

exports.color_tertiary_8 = color_tertiary_8;
var size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  mobileXL: "600px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "1920px",
  desktopL: "1920px" // Same size as desktop (for now)
}; // named devices for media queries.

exports.size = size;
var device = {
  mobileS: "(min-width: ".concat(size.mobileS, ")"),
  mobileM: "(min-width: ".concat(size.mobileM, ")"),
  mobileL: "(min-width: ".concat(size.mobileL, ")"),
  mobileXL: "(min-width: ".concat(size.mobileXL, ")"),
  tablet: "(min-width: ".concat(size.tablet, ")"),
  laptop: "(min-width: ".concat(size.laptop, ")"),
  laptopL: "(min-width: ".concat(size.laptopL, ")"),
  desktop: "(min-width: ".concat(size.desktop, ")"),
  desktopL: "(min-width: ".concat(size.desktop, ")")
};
exports.device = device;
var theme = {
  color_background: color_primary_1,
  color_title: color_primary_7,
  color_subtitle: color_primary_2,
  color_heading_1: color_primary_7,
  color_heading_2: color_primary_2,
  color_heading_3: color_primary_2,
  color_heading_4: color_primary_2,
  color_heading_5: color_primary_2,
  color_heading_6: color_primary_2,
  color_accent: color_primary_4,
  color_heading: color_primary_3,
  color_text: color_primary_3,
  color_text_dimmed: color_primary_6,
  color_text_bold: color_primary_6,
  color_text_accent: color_primary_2,
  font_family_main: "\"Open Sans\", sans-serif",
  font_family_alt: "\"BeaufortforLOL-Medium\", serif",
  background_image: undefined,
  background_image_repeat: "no-repeat",
  supports_uppercasing: true,
  /*  Email Form settings - these values are used in case your website
   *  1) does NOT set its own email_form_settings object in the theme
   *  passed to your site's styled-components ThemeProvider
   *  and 2) imported this Base Theme from the shared library and wrapped your app
   *  or component with the Base Theme
   */
  email_form_font_family: "FF Mark W05",
  email_form_font_color: "#F9F9F9",
  email_form_button_color: "rgba(209, 54, 57, 1)",
  email_form_background_color: "#292727",
  email_form_background_image: "https://assetcdn.rgpub.io/public/live/forge-archive-hosting/themageseeker/79935724723034f7c7f99294b4ce57af.jpg",
  device_media: device,
  device_size: size
};
exports.theme = theme;
var _default = theme;
exports.default = _default;